// src/components/mindworkout/sections/WorkoutFeatureSection.js
import React from 'react';
import styled from 'styled-components';

const SectionContainer = styled.section`
    padding: 5rem 2rem;
    background: #f8f9fa;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

const SectionTitle = styled.h2`
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 3rem;
    color: #333;
`;

const FeaturesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
`;

const FeatureCard = styled.div`
    background: white;
    padding: 2rem;
    border-radius: 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
    }
`;

const FeatureIcon = styled.div`
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    background: ${props => props.color};
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
`;

const FeatureTitle = styled.h3`
    font-size: 1.25rem;
    margin-bottom: 1rem;
    color: #333;
`;

const FeatureDescription = styled.p`
    color: #666;
    line-height: 1.6;
`;

const features = [
    {
        icon: '🎯',
        title: '집중력 훈련',
        description: 'SART, CPT 등 과학적으로 검증된 방법으로 집중력을 향상시키세요',
        color: '#4CAF50'
    },
    {
        icon: '😤',
        title: '인내력 강화',
        description: '지연 만족 훈련으로 충동을 조절하고 인내심을 기르세요',
        color: '#FF9800'
    },
    {
        icon: '🧘',
        title: '감정조절 마스터',
        description: '인지재평가와 마음챙김으로 감정을 다스리는 법을 배우세요',
        color: '#9C27B0'
    },
    {
        icon: '💝',
        title: '공감력 향상',
        description: '표정 인식과 관점 취하기로 타인을 이해하는 능력을 키우세요',
        color: '#2196F3'
    }
];

const WorkoutFeatureSection = () => {
    return (
        <SectionContainer>
            <ContentWrapper>
                <SectionTitle>4가지 핵심 정신력 영역</SectionTitle>
                <FeaturesGrid>
                    {features.map((feature, index) => (
                        <FeatureCard key={index}>
                            <FeatureIcon color={feature.color}>
                                {feature.icon}
                            </FeatureIcon>
                            <FeatureTitle>{feature.title}</FeatureTitle>
                            <FeatureDescription>{feature.description}</FeatureDescription>
                        </FeatureCard>
                    ))}
                </FeaturesGrid>
            </ContentWrapper>
        </SectionContainer>
    );
};

export default WorkoutFeatureSection;
